var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconTypeCellReference = function SvgMiconTypeCellReference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M4 20v2h4.586L2 28.586 3.414 30 10 23.414V28h2v-8zM30 10l-6-6-1.414 1.414L27.172 10l-4.586 4.586L24 16zM18.068 2.001l-4.15 15.483 1.932.518L20 2.52zM4 10l6-6 1.414 1.414L6.828 10l4.586 4.586L10 16z"
  })));
};
export default SvgMiconTypeCellReference;